import * as React from "react";
import { useState } from "react";
import { jfetch } from "../../utils";

interface IProps {
  liked: boolean;
  userContext: any;
  courseId: number;
  likeId: number;
}

function Like(props: IProps) {
  const [liked, setLiked] = useState(props.liked)
  const [like, setLike] = useState(props.likeId)
  let cn = liked ? 'fa-heart' : 'fa-heart-o'

  function toggleLike(){
    if(liked){
      jfetch.delete(`/likes/${like}`)
    }
    else{
      jfetch.post('/likes', {
        like: {
          likeable_type: 'Library::Course',
          likeable_id: props.courseId
        }
      })
      .then((resp) => {
        setLike(resp.like_id)
      })
    }
    setLiked(!liked)
  }

  return (
    <div style={{paddingTop:'20px'}}>
      <a style={{fontSize:'23px', color: "#e81111", cursor:"pointer"}} onClick={toggleLike}> 
        <i className={`fa ${cn}`} />
      </a>
    </div>
  );
}

export default Like;



// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/Like.tsx